(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["footer-links"] && !Shopify.designMode) return;
  try {
    const FOOTER_LINKS_DESKTOP = '(width >= 64rem)';

  class FooterLinksColumn extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.footer-links__trigger');
      this.panel = this.querySelector('.footer-links__panel');
      if (!this.trigger || !this.panel) return;

      this.accordion = this.dataset.accordion === 'true';
      this.mql = window.matchMedia(FOOTER_LINKS_DESKTOP);
      this._onToggle = this._onToggle.bind(this);
      this._sync = this._sync.bind(this);

      this._onAnchorClick = this._onAnchorClick.bind(this);

      this.trigger.addEventListener('click', this._onToggle);
      this.mql.addEventListener('change', this._sync);
      this.addEventListener('click', this._onAnchorClick);
      this._sync();
    }

    disconnectedCallback() {
      this.trigger?.removeEventListener('click', this._onToggle);
      this.mql?.removeEventListener('change', this._sync);
      this.removeEventListener('click', this._onAnchorClick);
    }

    // Anchor links resolve to the homepage. When the target is already on this
    // page, scroll to it instead of reloading; otherwise let the browser navigate
    // and the native hash jump handle it.
    _onAnchorClick(event) {
      const link = event.target.closest('a[data-anchor]');
      if (!link) return;

      const target = document.getElementById(link.dataset.anchor);
      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.replaceState(null, '', `#${link.dataset.anchor}`);
    }

    get isDesktop() {
      return this.mql.matches;
    }

    _onToggle() {
      if (this.isDesktop || !this.accordion) return;
      this._setOpen(this.dataset.open !== 'true');
    }

    _setOpen(open) {
      this.dataset.open = open ? 'true' : 'false';
      this.trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      this.panel.toggleAttribute('inert', !open && !this.isDesktop);
    }

    _sync() {
      if (this.isDesktop || !this.accordion) {
        this._setOpen(true);
        this.trigger.setAttribute('tabindex', '-1');
      } else {
        this.trigger.removeAttribute('tabindex');
        this._setOpen(false);
      }
    }
  }

  if (!customElements.get('footer-links-column')) {
    customElements.define('footer-links-column', FooterLinksColumn);
  }
  } catch(e) { console.error(e); }
})();

})();
